import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "components/ui/form";
import SingleDatePicker from "components/input-range-data";
import { FilterDateRangeProps } from "../../../data/types";
import { parseDMYToDate } from "@/utils/format-date-ddmmyyyy";
import { formatDate } from "@/utils/format-date";

export function FilterRangeDate({ control }: FilterDateRangeProps) {
  return (
    <>
      {/* Data Inicial */}
      <FormField
        control={control}
        name="dateStart"
        render={({ field }) => (
          <FormItem className="space-y-2">
            <FormLabel className="block text-sm font-medium text-gray-700">
              Data Inicial *
            </FormLabel>
            <FormControl>
              <SingleDatePicker
                id="filter-date-start"
                date={parseDMYToDate(field.value) ?? undefined}
                onDateChange={(date) => {
                  field.onChange(
                    date ? formatDate(date, { fallback: "" }) : "",
                  );
                }}
                className="[&>div]:gap-0"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Data Final */}
      <FormField
        control={control}
        name="dateEnd"
        render={({ field }) => (
          <FormItem className="space-y-2">
            <FormLabel className="block text-sm font-medium text-gray-700">
              Data Final *
            </FormLabel>
            <FormControl>
              <SingleDatePicker
                id="filter-date-end"
                date={parseDMYToDate(field.value) ?? undefined}
                onDateChange={(date) => {
                  field.onChange(
                    date ? formatDate(date, { fallback: "" }) : "",
                  );
                }}
                className="[&>div]:gap-0"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
